import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ceb',
    fullName: 'Cebuano',
    nativeName: 'Cebuano',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Usa ka Kahibulongan ang Moabot",
    landing_subtitle: "Ang ArgVoid usa ka app ug game development studio. Pagbantay, bag-ong mga butang ang umaabot!",
    select_language: "Pilia ang Pinulongan",
    search_placeholder: "Pangitag mga pinulongan...",
    terms_title: "Mga Termino sa Serbisyo",
    policy_title: "Patakaran sa Pagkapribado",
    cookies_title: "Patakaran sa Cookie",
    terms_content: `
        <strong>1. Pagdawat sa Mga Termino</strong><br>
        Pinaagi sa pag-access sa ArgVoid, kini nga Mga Termino sa Serbisyo gidawat. Kung kini nga mga termino wala giuyonan, ang serbisyo kinahanglan dili gamiton.<br><br>

        <strong>2. Paggamit sa Platform</strong><br>
        Ang ArgVoid ug ang mga aplikasyon niini gihatag "as is" para sa mga katuyoan sa impormasyon ug paglalang. Ang serbisyo kinahanglang gamiton lamang alang sa legal nga katuyoan.<br><br>

        <strong>3. Gidili nga Paggawi</strong><br>
        Ang pagpahimulos sa mga kahuyangan sa site, pag-spam, o pagsulay sa dili awtorisado nga pag-access sa imprastraktura hugot nga gidili.<br><br>

        <strong>4. Disclaimer</strong><br>
        Ang plataporma ug mga serbisyo mahimong usbon sa bisan unsang oras nga walay pahibalo. Wala’y gihatag nga garantiya bahin sa oras sa oras o pagkaanaa sa serbisyo.
    `,
    policy_content: `
        <strong>1. Koleksyon sa Impormasyon</strong><br>
        Ang plataporma wala magkinahanglan og panghimatuud sa user o paghimo og account karong panahona. Walay personal nga impormasyon sa pag-ila (sama sa mga ngalan o email address) ang aktibong nakolekta gikan sa mga bisita.<br><br>

        <strong>2. Paggamit sa Data</strong><br>
        Ang sukaranan, wala mailhi nga analytics mahimong makolekta aron masabtan ang trapiko sa site ug mapaayo ang mga aplikasyon. Kini nga datos wala nalambigit sa indibidwal nga identidad sa tiggamit.<br><br>

        <strong>3. Mga Serbisyo sa Ikatulong Partido</strong><br>
        Ang mga tighatag sa ikatulo nga partido mahimong magamit alang sa mga serbisyo sa pag-host ug analytics. Ang mga batasan sa pagkapribado niining mga taghatag nagdumala sa wala mailhi nga datos nga giproseso sa ilang imprastraktura.<br><br>

        <strong>4. Seguridad sa Data</strong><br>
        Ang makatarunganon nga mga lakang sa seguridad gipatuman aron mapanalipdan ang plataporma. Bisan pa, walay paagi sa pagpasa sa Internet ang hingpit nga luwas.<br><br>
    `,
    cookies_content: `
        <strong>1. Unsa ang Cookies ug Lokal nga Pagtipig?</strong><br>
        Ang mga cookie ug lokal nga storage sa browser maoy gagmayng mga file sa datos nga gitipigan sa device aron mahinumdoman ang mga gusto sa configuration sa tibuok pagbisita.<br><br>

        <strong>2. Katuyoan sa Paggamit</strong><br>
        Ang Browser LocalStorage estrikto nga gigamit sa pagtipig sa mga setting sa configuration, sama sa:<br>
        - Mga gusto sa pinulongan<br>
        - Konfigurasyon sa user interface (pananglitan, layout o tema setting)<br>
        - Temporaryong aplikasyon cache<br><br>

        <strong>3. Walay Pagsubay</strong><br>
        Ang mga cookies ug lokal nga pagtipig wala gigamit alang sa pag-advertise o mga katuyoan sa pagsubay sa ikatulo nga partido. Ang tanan nga gitipigan nga datos estrikto alang sa kinauyokan nga pagpaandar sa plataporma.<br><br>

        <strong>4. Pagkontrol</strong><br>
        Ang data sa browser mahimong ma-clear sa bisan unsang oras pinaagi sa mga setting sa browser, nga mag-reset sa bisan unsang lokal nga mga pag-configure.
    `,
    cookie_consent_text: "Gigamit namo ang mga batakang cookies aron masiguro nga ang website naglihok sa husto, sama sa pagpabilin nga aktibo sa imong sesyon, pagtipig sa imong gusto sa pinulongan, ug uban pang custom nga mga configuration.",
    read_policy: "Basaha ang Patakaran sa Cookie",
    support_title: "Kontaka ang Suporta",
    support_subject_label: "Hilisgutan",
    support_message_label: "Mensahe",
    support_submit_button: "Ipadala ang Mensahe",
    support_hint: "Mubo nga sulat: Kini magbukas sa imong default nga email application aron ipadala ang mensahe.",
    support_success_msg: "Pag-abli sa imong email app...",
    support_error_msg: "Napakyas sa pagpadala sa mensahe. Palihug sulayi pag-usab unya.",
    explorer_title: "Tigpangita",
    history_title: "Kasaysayan",
    animation_title: "Animasyon",
    config_title: "Pag-configure",
    tool_mouse: "Pagpili (Ctrl+M)",
    tool_brush: "Brush (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Solid/Clear)",
    tool_eraser: "Panas (Ctrl+E)",
    tool_brush_size: "I-adjust ang Gidak-on sa Brush",
    tool_bucket: "Pun-a (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "I-rotate (Ctrl+Shift+R)",
    tool_flip_h: "I-flip H (Ctrl+Shift+H)",
    tool_flip_v: "I-flip V (Ctrl+Shift+V)",
    tool_transpose: "Pagbalhin (Ctrl+Shift+T)",
    label_width: "Lapad",
    label_height: "Gitas-on",
    label_frames: "Gidaghanon sa mga Frame",
    label_animation: "Estilo sa Animasyon",
    label_background_color: "Kolor sa Background",
    label_interval: "Interbal",
    tool_anim_config: "Animation Configuration",
    label_new_width: "Bag-ong Lapad",
    label_new_height: "Bag-ong Taas",
    label_apply: "Pag-aplay",
    label_colors: "Mga kolor",
    label_size: "Gidak-on",
    label_tolerance: "Pagkamatugtanon",
    val_horizontal: "Pahigda",
    val_vertical: "Bertikal",
    val_sequence: "Pagkasunodsunod",
    val_bounce: "Bounce",
    val_random: "Random",
    val_solid: "Solid",
    val_clear: "Klaro",
    action_add_sheet: "Bag-ong Palid",
    action_import: "Import",
    action_export: "Export",
    action_sort_projects: "Pagsunud-sunod",
    sort_date_old: "Kinatigulangan Una",
    sort_date_new: "Pinakabag-o Una",
    sort_name_az: "Ngalan (A-Z)",
    sort_name_za: "Ngalan (Z-A)",
    action_new_sprite: "Bag-ong Sprite",
    action_new_project: "Bag-ong Proyekto",
    modal_save_all_title: "I-save ang Tanan nga mga Pagbag-o",
    modal_save_all_desc: "Pilia ang mga kabtangan nga tipigan:",
    modal_save_selected: "I-save ang Gipili",
    action_saved: "Naluwas",
    modal_create_sprite_title: "Paghimo Bag-ong Sprite",
    modal_create_project_title: "Paghimo Bag-ong Proyekto",
    modal_add_sheet_title: "Idugang ang Bag-ong Sheet",
    modal_rename_sheet_title: "Usba ang ngalan sa Sheet",
    modal_rename_sprite_title: "Usba ang ngalan sa Sprite",
    modal_delete_sprite_title: "Pagtangtang sa Sprite",
    modal_delete_project_title: "Pagtangtang sa Proyekto",
    modal_delete_sheet_title: "Pagtangtang sa Sheet",
    placeholder_sprite_name: "Ngalan",
    placeholder_project_name: "Ngalan",
    placeholder_sheet_name: "Ngalan",
    placeholder_new_name: "Bag-ong Ngalan",
    action_create: "Paghimo",
    action_add: "Idugang",
    action_rename: "Usba ang ngalan",
    action_duplicate: "Duplicate",
    action_delete: "Pagtangtang",
    action_cancel: "Pagkanselar",
    confirm_delete_sprite: "Sigurado ka ba nga gusto nimong papason kini nga sprite?",
    confirm_delete_project: "Sigurado ka ba nga gusto nimong papason kini nga proyekto? Ang tanan nga mga sprite matangtang.",
    confirm_delete_sheet: "Sigurado ka ba nga gusto nimong papason kini nga panid?",
    err_select_sprite: "Palihug pagpili og usa ka sprite una.",
    err_select_project: "Palihug pagpili una og proyekto.",
    err_name_empty: "Ang ngalan dili mahimong walay sulod.",
    err_sprite_exists: "Usa ka sprite nga adunay kana nga ngalan naglungtad na.",
    err_project_exists: "Adunay usa ka proyekto nga adunay kana nga ngalan.",
    err_no_content: "Walay sulod nga i-save.",
    err_no_changes: "Walay mga kausaban nga i-save.",
    err_delete_last_sheet: "Dili mapapas ang kataposang panid.",
    err_extract_frames: "Dili makuha ang bisan unsang mga frame.",
    err_indexeddb: "Napakyas sa pagluwas sa lokal. Mahimong dili suportado sa imong browser ang IndexedDB.",
    msg_upload_success: "Malampuson ang Pag-upload: {0}",
    msg_upload_failed: "Napakyas ang pag-upload: {0}",
    msg_save_success: "Malampuson ang pagluwas.",
    msg_saving: "Nagtipig...",
    msg_multi_save_result: "Gitipigan ang {0} nga mga kabtangan. {1} kapakyasan.",
    menu_title: "Menu",
    menu_save: "Tipigi",
    menu_save_all: "I-save ang Tanan",
    menu_support: "Kontaka ang Suporta",
    label_local_storage: "Lokal nga Pagtipig",
    label_sign_in: "Sign In",
    modal_export_title: "I-export ang Sprite",
    label_filename: "ngalan sa file",
    label_format: "Porma",
    action_export_confirm: "Export",
};

export default translations;
